import { all, call, put, takeLatest } from 'redux-saga/effects';

import { request } from '@app/services';
import { searchItems, searchItemsFailed, searchItemsSuccess } from './slice';
import * as endpoints from './endpoints';

function* searchItemsSaga({ payload }: ReturnType<typeof searchItems>): any {
  try {
    const response = yield call(request.get, `${endpoints.getRecipes}${payload}`);
    yield put(searchItemsSuccess(response.data));
  } catch (error: any) {
    yield put(searchItemsFailed(error));
  }
}

function* searchResultSagas() {
  yield all([takeLatest(searchItems, searchItemsSaga)]);
}
export { searchResultSagas };
